import {Box, createTheme, CssBaseline, ThemeProvider} from '@mui/material'
import {createContext, useMemo, useState} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import LoggedContainer from "./pages/LoggedContainer";
import LoginPage from "./pages/auth/LoginPage";
import { Provider } from 'react-redux';
import { store } from './store';

export const ThemeContext = createContext()

export default function App() {
    const [mode, setMode] = useState('light')

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode
                    , primary: {
                        main: mode === 'light' ? '#5cbec4' : '#f6d552'
                    }
                    , background: {
                        default: mode === 'light' ? '#fff' : '#10171f'
                        , paper: mode === 'light' ? '#fff' : '#10171f'
                    }
                }
                , typography: {
                    root: {
                        color: '#ccc'
                    }
                    , h3: {
                        fontSize: '1.5rem'
                        , fontWeight: 'bold'
                    }
                    , h5: {
                        fontSize: '1.2rem'
                    }
                    , h4: {
                        fontSize: '1.4rem'
                    }
                }
                , mixins: {
                    drawerWidth: 256
                    , formDrawerWidth: 320
                    , toolbar: {
                        minHeight: 64
                    }
                }
                , components: {
                    MuiCardHeader: {
                        styleOverrides: {
                            root: {
                                padding: '0 0 0 10px'
                            }
                        }
                    }
                    , MuiPaper: {
                        styleOverrides: {
                            gap: '12px'
                        }
                    }
                    , MuiDataGrid: {
                        styleOverrides: {
                            root: {
                                color: 'black'
                                , backgroundColor: '#ccc'
                            }
                            , columnHeaderTitle: {
                                fontWeight: 'bold'
                                , textTransform: 'capitalize'
                            }
                            , toolbarContainer: {
                                backgroundColor: '#aaa'
                            }
                        }
                    }
                    , MuiCollapse: {
                        styleOverrides: {
                            root: ({theme}) => ({
                                marginRight: '0px'
                                ,
                                marginLeft: '10px'
                                ,
                                boxShadow: theme.palette.mode === 'dark' ? '-2px 0px 1px #f6d552' : '-1px 0px 1px rgba(0, 0, 0, 0.2)'
                                ,
                                borderRadius: '2px'
                            })
                        }
                    },
                    MuiButton: {
                        styleOverrides: {
                            root: {
                                fontWeight: 400,
                            },
                            contained: {
                                '&.Mui-disabled': {
                                    backgroundColor: '#d8d8d8'
                                }
                            },
                            outlined: {
                                '&.Mui-disabled': {
                                    backgroundColor: '#d8d8d8'
                                }
                            }
                        }
                    }
                }
            }),
        [mode]
    )

    const toggleTheme = mode => {
        if (mode) setMode(mode)
        else setMode(prevMode => (prevMode === 'light' ? 'dark' : 'light'))
    }

    return (
        <Provider store={store}>
            <Box sx={{height: '100vh', overflowY: 'none'}}>
                <ThemeContext.Provider value={{mode, toggleTheme}}>
                    <ThemeProvider theme={theme}>
                        <CssBaseline/>
                        <Routes>
                            <Route path="/login" element={<LoginPage/>}></Route>
                            {/*<Route path="asia/*" element={<AsiaContainer/>}></Route>*/}
                            <Route path='/' element={<Navigate to="/home" />} exact/>
                            <Route path="/*" element={<LoggedContainer/>}></Route>
                        </Routes>
                    </ThemeProvider>
                </ThemeContext.Provider>
            </Box>
        </Provider>
    )
}